import type { Frame, FrameVariant } from "@/types/dragon-tiles";

/**
 * Resolves the text variant a FrameCard represents in its single "text" bucket.
 *
 * The card only ever displays (and therefore test-sends) SMS or MMS — never
 * RCS. RCS-primary tiles always persist an SMS or MMS fallback variant
 * (see `channelDerivation.ts`), so we prefer the SMS variant and fall back to
 * MMS. Mirrors the display selection in `FrameCardPreview`.
 */
export function resolveTextCardVariant(
  frame: Frame,
): { variant: FrameVariant; medium: "sms" | "mms" } | null {
  const sms = frame.frame_variants.find((v) => v.medium === "sms");
  if (sms) return { variant: sms, medium: "sms" };
  const mms = frame.frame_variants.find((v) => v.medium === "mms");
  if (mms) return { variant: mms, medium: "mms" };
  return null;
}
